const API_BASE = process.env.REACT_APP_API_URL || '/api';

export function getApiBase() {
  return API_BASE.replace(/\/$/, '');
}

export async function apiGet(path) {
  const res = await fetch(`${getApiBase()}${path}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || res.statusText);
  }
  return res.json();
}

export async function apiPost(path, body) {
  const res = await fetch(`${getApiBase()}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body ?? {}),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || res.statusText);
  }
  return res.json();
}

export async function apiPut(path, body) {
  const res = await fetch(`${getApiBase()}${path}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body ?? {}),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || res.statusText);
  }
  return res.json();
}

export async function apiDelete(path) {
  const res = await fetch(`${getApiBase()}${path}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || res.statusText);
  }
  return res.json();
}

export async function apiUpload(path, formData) {
  const res = await fetch(`${getApiBase()}${path}`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || res.statusText);
  }
  return res.json();
}

export async function downloadExport(path) {
  const res = await fetch(`${getApiBase()}${path}`, {
    credentials: 'include',
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || res.statusText);
  }
  const blob = await res.blob();
  const disposition = res.headers.get('Content-Disposition') || '';
  const match = disposition.match(/filename="([^"]+)"/);
  const filename = match ? match[1] : `zemaxi-cms-backup-${new Date().toISOString().slice(0, 10)}.json`;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export function formatProductForDisplay(p) {
  const tag = p.buttonText && p.buttonText.startsWith('$')
    ? 'premium'
    : (p.cost || 'free').toLowerCase();
  return {
    id: p.id,
    img: p.overlayImage,
    alt: p.name,
    tag,
    title: p.name,
    description: p.description,
    link: p.buttonLink,
    btnClass: p.cost === 'Premium' ? 'btn btn-product-premium2' : 'btn btn-product',
    btnText: p.buttonText,
    featured: p.featured,
    categories: [p.cost, ...(p.tags || []), p.location].filter(Boolean)
      .concat(tag === 'premium' ? 'Premium' : [])
      .concat(tag === 'free' ? 'Free' : []),
    location: p.location,
  };
}
